import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { currency } from 'Helpers/Formats';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/UI/Typography';
import Button from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Button';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { List } from '@material-ui/core';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import fr from 'facet-rest';
import { navigateToPage } from 'Views/Page/Content/Templates';
import useUserContext from 'Context/UserContext';
import ListItem from './Item';


const styles = theme => ({
  root: {},
  balance: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignContent: 'center',
    marginTop: theme.spacing(5),
    padding: theme.spacing(1, 0),
    borderTop: '2px solid',
    borderTopColor: theme.palette.grey[300],
  },
  assetBallance: {
    fontWeight: 500,
  },
  hidden: {
    visibility: 'hidden',
  },
});

const AccountList = ({
  className,
  classes,
  color,
  items,
  totalBalance,
  width,
  readOnly,
  AddAccountButtonProps,
}) => {
  const { householdResource } = useSimpleHousehold();
  const { isAgent } = useUserContext();


  const addAccountsRel = householdResource.withRelationship(fr.relationships.addAccounts.name, (rel) => rel, () => null);
  const handleClickAddAccount = () => {
    const params = householdResource.withRelationship(fr.relationships.addRealAssetOrAccountWizard.name, (rel) => {
      return { modalSelfLink: rel.link('related').url() };
    }, () => {});
    navigateToPage(addAccountsRel.link('related').url(), isAgent, params);
  };

  return (
    <div className={classNames(className, classes.root)}>
      <List
        disablePadding
        style={{ width }}
      >
        {
          items.map((item) => {
            return (
              <ListItem
                key={`${item.name}-${item.balance}`}
                item={item}
                color={color}
                readOnly={readOnly}
              />
            );
          })
        }
      </List>
      <div className={classes.balance}>
        {addAccountsRel ? (
          <Button
            className={classNames(classes.linkButton, {
              [classes.hidden]: readOnly,
            })}
            onClick={handleClickAddAccount}
            padding="none"
            variant="text"
            color={color}
            startIcon={<AddCircleIcon />}
            {...AddAccountButtonProps}
          >
          Add Account
          </Button>
        )
          : null}

        <Typography
          noWrap
          variant="h3"
          color={color}
          className={classes.assetBallance}
        >
          {currency(parseFloat(totalBalance), false)}
        </Typography>
      </div>
    </div>
  );
};

AccountList.defaultProps = {
  className: '',
  color: 'primaryGray',
  readOnly: false,
  AddAccountButtonProps: {},
};

AccountList.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  color: PropTypes.string,
  items: PropTypes.array.isRequired,
  totalBalance: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  readOnly: PropTypes.bool,
  AddAccountButtonProps: PropTypes.object,
};

export default withStyles(styles)(AccountList);
